import React, { useEffect, useState } from 'react';
import LcIconLink from '../LcIconLink';
import Parse from 'html-react-parser';


import './index.css';
import LcLoading from '../LcLoading';
import { CircularProgress } from '@mui/material';
import { PPIconLink } from 'processor-plataform-ui';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { PrefState } from '../../../store/reducers/prefReducer';

interface Props {
    visible: boolean
}

const ToolTipHelper: React.FC<Props> = (props) => {

    const [visible, setVisible] = useState<boolean>(false);
    const [expandedFields, setExpandedFields] = useState<any[]>([
        {
            text: "comentario teste 2",
            value: "Há cinco minutos"
        },
        {
            text: "comentario teste 1",
            value: "Há duas horas"
        }
    ]);
    const [mousePosition, setMousePosition] = useState<{ x: number, y: number }>({ x: 600, y: 103 });
    const pref = useSelector<RootState, PrefState>(state => state.pref);

    useEffect(() => {
        setVisible(props.visible);
    }, [props.visible])

    const [fields, setFields] = useState<any>([
        {
            "text": "Chamado",
            "subValue": "123456",
            "propSubvalue": {
                "fontSize": "14px",
                "whiteSpace": "pre-line",
                "fontWeight": "bold"
            }
        },
        {
            "text": "Solicitante: ",
            "value": "Henrique Garcia",
            "propText": {
                "color": "#8B90A3",
                "fontWeight": "bold",
                "fontSize": "14px"
            },
            "propValue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line",
                "marginBottom": "1px",
                "wordBreak": "break-word"
            }
        },
        {
            "text": "",
            "value": "Processor - Central de Serviços Processor",
            "propValue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "Data e hora",
            "value": "18/01 às 11:32",
            "propText": {
                "color": "#8B90A3",
                "fontWeight": "bold",
                "fontSize": "14px"
            },
            "propValue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "SLA / SLO",
            "value": "",
            "propText": {
                "color": "#8B90A3",
                "fontWeight": "bold",
                "fontSize": "14px",
                "marginBottom": "-3px"
            }
        },
        {
            "text": "Resposta:",
            "subValue": "32%  vence em 18/01/2023 20:32, restam ainda  6 horas ",
            "propsText": {
                "fontWeight": "500",
                "fontSize": "12px"
            },
            "propSubvalue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "Solução:",
            "subValue": "29%  vence em 18/01/2023 14:22, restam ainda  8 horas ",
            "propsText": {
                "fontWeight": "500",
                "fontSize": "12px"
            },
            "propSubvalue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "Status",
            "value": "",
            "propText": {
                "color": "#8B90A3",
                "fontWeight": "bold",
                "fontSize": "14px"
            }
        },
        {
            "text": "Trabalho",
            "value": "",
            "subValue": "Terminado",
            "propText": {
                "fontWeight": "500",
                "fontSize": "12px"
            },
            "propSubvalue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "Chamado",
            "value": "",
            "subValue": "Concluída",
            "propText": {
                "fontWeight": "500",
                "fontSize": "12px"
            },
            "propSubvalue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        },
        {
            "text": "Prioridade",
            "value": "",
            "subValue": "Normal",
            "propText": {
                "fontWeight": "500",
                "fontSize": "12px"
            },
            "propSubvalue": {
                "fontWeight": "bold",
                "fontSize": "12px",
                "whiteSpace": "pre-line"
            }
        }
    ]);

    const [icon, setIcon] = useState<string>("ppi ppi-chevron-right");

    useEffect(() => {
        const openTooltipCommentsPref = pref.dataLocal?.openTooltipCommentsPref ?? false;
        setIcon(`ppi ppi-chevron-${(openTooltipCommentsPref) ? "left" : "right"}`);
    }, [pref.dataLocal?.openTooltipCommentsPref])

    return (
        <div className="lc-tooltipHelper">
            {props.children}
            {
                visible &&
                <div className={`body rigth`}
                    style={{ top: mousePosition.y + "px", left: mousePosition.x + "px", position: 'relative' }}
                >
                    <div className="content">
                        <div style={{ float: "right" }}>
                            <PPIconLink icon={icon} size={"small"} onClick={() => { }} color='black' />
                        </div>
                        {
                            fields.map((campo, index) => {

                                return (
                                    <div key={index} className={"divOrderSpan"}>
                                        {
                                            (campo.subValue || campo.text) &&
                                            <span className={"spanText"} style={{ ...campo.propText }}> {campo.text} <span style={{ ...campo.propSubvalue }}>{campo.subValue}</span></span>
                                        }
                                        {
                                            campo.value &&
                                            <span className={"spanValue"} style={{ ...campo.propValue }}> {campo.value} </span>
                                        }
                                    </div>
                                )
                            })
                        }
                        {
                            pref.dataLocal?.openTooltipCommentsPref &&
                            <div className={"divOrderExpandedFields"}>
                                <div className={"divExpandedFields"}>
                                    {
                                        expandedFields.map((campo, index) => {
                                            return (
                                                <div key={index} className={"divOrderExpandedFieldsContent"}>
                                                    <span className={"spanExpandedValue"} style={{ ...campo.propValue }}> {campo.value} </span>
                                                    <span className={"spanExpandedText"} style={{ ...campo.propText }}> {campo.text} </span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default ToolTipHelper;